import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change( event ) {
    console.log(event.target.selectedOptions[0].value)
  }
}
